/* LightSeek product detail interactions — mirrors frontend/web ProductDetailClient.tsx */
(function () {
  'use strict';

  var data = window.LS_PRODUCT || {};
  var root = document.querySelector('.pd-page');
  if (!root) return;

  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };

  var STORAGE_KEY = 'lightseek-inquiry-products';

  function readInquiry() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function addToInquiry(quantity) {
    var list = readInquiry();
    var exists = list.some(function (p) { return p.id === data.id; });
    if (!exists) {
      list.push({
        id: data.id,
        name: data.name,
        model: data.model,
        image: data.image,
        url: data.url,
        quantity: Math.max(1, quantity || 1)
      });
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
    }
    window.location.href = data.inquiryUrl || '/pages/inquiry';
  }

  /* ---------------- toast ---------------- */
  var toastEl = $('[data-toast]');
  var toastTimer = null;
  function showToast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.hidden = false;
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.hidden = true; }, 2000);
  }

  /* ---------------- gallery ---------------- */
  var thumbs = $$('.pd-thumb');
  var mainImg = $('[data-main-image]');
  var mainBox = $('[data-gallery-main]');
  var thumbList = $('[data-thumbs]');
  var lens = $('[data-zoom-lens]');
  var zoomPanel = $('[data-zoom-panel]');
  var activeIndex = 0;
  var LENS_SIZE = 120;

  function setActiveImage(i) {
    if (!thumbs.length) return;
    activeIndex = (i + thumbs.length) % thumbs.length;
    thumbs.forEach(function (t, idx) { t.classList.toggle('active', idx === activeIndex); });
    var t = thumbs[activeIndex];
    if (mainImg) {
      mainImg.src = t.getAttribute('data-src');
      mainImg.setAttribute('data-full', t.getAttribute('data-full') || '');
    }
    hideZoom();
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { setActiveImage(i); });
  });
  var prevBtn = $('[data-gallery-prev]');
  var nextBtn = $('[data-gallery-next]');
  if (prevBtn) prevBtn.addEventListener('click', function () { setActiveImage(activeIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { setActiveImage(activeIndex + 1); });
  $$('.pd-thumb-arrow').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!thumbList) return;
      thumbList.scrollBy({ top: Number(btn.getAttribute('data-thumb-scroll')) * 78, behavior: 'smooth' });
    });
  });

  function hideZoom() {
    if (lens) lens.hidden = true;
    if (zoomPanel) zoomPanel.hidden = true;
  }

  if (mainBox && mainImg && lens && zoomPanel) {
    mainBox.addEventListener('mousemove', function (e) {
      if (window.innerWidth <= 1024) return;
      var rect = mainBox.getBoundingClientRect();
      var px = e.clientX - rect.left;
      var py = e.clientY - rect.top;
      var full = mainImg.getAttribute('data-full') || mainImg.src;
      lens.hidden = false;
      zoomPanel.hidden = false;
      lens.style.left = Math.min(rect.width - LENS_SIZE, Math.max(0, px - LENS_SIZE / 2)) + 'px';
      lens.style.top = Math.min(rect.height - LENS_SIZE, Math.max(0, py - LENS_SIZE / 2)) + 'px';
      zoomPanel.style.backgroundImage = 'url(' + full + ')';
      zoomPanel.style.backgroundPosition = (px / rect.width) * 100 + '% ' + (py / rect.height) * 100 + '%';
      zoomPanel.style.backgroundSize = ((rect.width / LENS_SIZE) * 100) + '% ' + ((rect.height / LENS_SIZE) * 100) + '%';
    });
    mainBox.addEventListener('mouseleave', hideZoom);
  }

  /* ---------------- sub-tab nav + scroll spy ---------------- */
  var subtabNav = $('.pd-subtab-nav');
  $$('.pd-subtab').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-tab');
      var el = document.getElementById(id);
      if (el) {
        var top = el.getBoundingClientRect().top + window.scrollY - 160;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          $$('.pd-subtab', subtabNav || root).forEach(function (b) {
            b.classList.toggle('active', b.getAttribute('data-tab') === entry.target.id);
          });
        }
      });
    }, { rootMargin: '-120px 0px -60% 0px' });
    $$('[data-tab-section]').forEach(function (s) { observer.observe(s); });
  }

  /* ---------------- sticky right panel ---------------- */
  var heroInfo = $('[data-hero-info]');
  var bp = $('[data-bp]');
  function updateSticky() {
    if (!heroInfo || !bp) return;
    var bottom = heroInfo.getBoundingClientRect().bottom;
    bp.classList.toggle('sticky-top', bottom < 120);
    bp.classList.toggle('sticky-bottom', bottom >= 120);
  }
  window.addEventListener('scroll', updateSticky, { passive: true });
  updateSticky();

  /* ---------------- share ---------------- */
  var shareBtn = $('[data-share]');
  var copied = $('[data-share-copied]');
  if (shareBtn) {
    shareBtn.addEventListener('click', function () {
      var url = window.location.href;
      if (navigator.share) {
        navigator.share({ title: data.name, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          if (copied) {
            copied.hidden = false;
            setTimeout(function () { copied.hidden = true; }, 2000);
          }
        }).catch(function () {});
      }
    });
  }

  /* ---------------- variants ---------------- */
  var selected = {};
  var quantities = {};
  var variants = $$('.pd-modal-group');
  var hasVariants = Number(data.hasVariants) || 0;
  var symbol = data.currencySymbol || '$';

  function priceNumber(str) {
    var m = String(str || '').replace(/,/g, '').match(/\d+(?:\.\d+)?/);
    return m ? parseFloat(m[0]) : 0;
  }

  function updateSubtotal() {
    var total = 0;
    $$('[data-qty]').forEach(function (input) {
      var val = input.getAttribute('data-qty');
      var qty = Math.max(0, Number(input.value) || 0);
      var btn = $('[data-group][data-value="' + cssEscape(val) + '"]', $('.pd-modal'));
      total += priceNumber(btn && btn.getAttribute('data-price')) * qty;
    });
    var out = $('[data-subtotal]');
    if (out) out.textContent = symbol + total.toFixed(2);
  }

  function cssEscape(v) {
    return String(v).replace(/"/g, '\\"');
  }

  function applySelection(group, value) {
    $$('[data-group="' + cssEscape(group) + '"]').forEach(function (b) {
      var on = b.getAttribute('data-value') === value;
      b.classList.toggle('selected', on);
      b.classList.toggle('unselected', !on);
    });
  }

  function updateDisplayPrice() {
    var powerValue = selected['power'];
    var priceText = '';
    if (powerValue) {
      var btn = $('.pd-bp-swatches [data-group="power"][data-value="' + cssEscape(powerValue) + '"]');
      if (btn) priceText = btn.getAttribute('data-price') || '';
    }
    if (priceText) {
      var display = $('[data-price]');
      if (display) display.textContent = priceText;
      var bpPrice = $('[data-bp-price]');
      if (bpPrice) bpPrice.textContent = priceText;
      var modalPrice = $('[data-modal-price]');
      if (modalPrice) modalPrice.textContent = priceText;
    }
  }

  function selectVariant(group, value, openModal) {
    selected[group] = value;
    applySelection(group, value);
    updateDisplayPrice();
    if (openModal) openModalFn();
  }

  /* ---------------- variant modal ---------------- */
  var overlay = $('[data-modal-overlay]');

  function modalZoom() {
    var root = overlay && overlay.closest ? overlay.closest('[data-ls-zoom]') : null;
    var z = root ? parseFloat(window.getComputedStyle(root).zoom) : 1;
    return z > 0 ? z : 1;
  }

  /* frontend/web reserves the social sidebar's width inside the modal overlay.
     The sidebar labels overflow their 44px boxes, so measure the leftmost
     visible edge instead of only the container box. */
  function modalSidebarPad() {
    var sidebar = document.querySelector('.social-sidebar');
    if (!sidebar) return 0;
    var sideStyle = window.getComputedStyle(sidebar);
    if (sideStyle.display === 'none' || sideStyle.visibility === 'hidden') return 0;
    var left = sidebar.getBoundingClientRect().left;
    var items = sidebar.querySelectorAll('.ss-item, .ss-label');
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var style = window.getComputedStyle(item);
      if (style.display === 'none' || style.visibility === 'hidden') continue;
      var rect = item.getBoundingClientRect();
      if (rect.width > 0) left = Math.min(left, rect.left);
    }
    return Math.max(0, window.innerWidth - left + 16) / modalZoom();
  }

  /* The admin preview bar is fixed to the viewport bottom and paints above the
     zoomed overlay; keep the bottom-pinned footer clear of it. The published
     store has no bar, so this is a no-op there (local's 吸底 behaviour). */
  function modalPreviewBarPad() {
    var bar = document.getElementById('PBarNextFrameWrapper');
    if (!bar) return 0;
    var style = window.getComputedStyle(bar);
    if (style.display === 'none' || style.visibility === 'hidden') return 0;
    var rect = bar.getBoundingClientRect();
    if (!rect.height || rect.bottom < window.innerHeight - 1) return 0;
    return rect.height / modalZoom();
  }

  function layoutModal() {
    if (!overlay || overlay.hidden) return;
    var sidePad = modalSidebarPad();
    overlay.style.paddingRight = sidePad > 0 ? sidePad + 'px' : '';
    var barPad = modalPreviewBarPad();
    overlay.style.bottom = barPad > 0 ? barPad + 'px' : '';
  }

  function openModalFn() {
    if (!overlay) return;
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    layoutModal();
  }
  function closeModal() {
    if (!overlay) return;
    overlay.hidden = true;
    document.body.style.overflow = '';
  }
  /* ls-zoom.js registers its own resize handler after this file, so wait for
     it to apply the new zoom before measuring. */
  window.addEventListener('resize', function () {
    setTimeout(layoutModal, 0);
  });

  $$('.pd-bp-swatch, .pd-bp-power-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      selectVariant(btn.getAttribute('data-group'), btn.getAttribute('data-value'), true);
    });
  });
  var selectNow = $('[data-open-modal]');
  if (selectNow) selectNow.addEventListener('click', openModalFn);

  $$('.pd-modal-swatch, .pd-modal-power-opt').forEach(function (btn) {
    btn.addEventListener('click', function () {
      selectVariant(btn.getAttribute('data-group'), btn.getAttribute('data-value'), false);
    });
  });

  $$('[data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var v = btn.getAttribute('data-qty-plus');
      var input = $('[data-qty="' + cssEscape(v) + '"]');
      if (input) { input.value = Math.max(0, Number(input.value || 0) + 1); updateSubtotal(); }
    });
  });
  $$('[data-qty-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var v = btn.getAttribute('data-qty-minus');
      var input = $('[data-qty="' + cssEscape(v) + '"]');
      if (input) { input.value = Math.max(0, Number(input.value || 0) - 1); updateSubtotal(); }
    });
  });
  $$('[data-qty]').forEach(function (input) {
    input.addEventListener('input', function () {
      input.value = String(Math.max(0, Number(input.value) || 0));
      updateSubtotal();
    });
  });

  if (overlay) {
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });
    var closeBtn = $('[data-modal-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) closeModal();
    });
  }

  /* ---------------- contact buttons ---------------- */
  var contactBtn = $('[data-contact]');
  if (contactBtn) {
    contactBtn.addEventListener('click', function () {
      if (hasVariants) { openModalFn(); return; }
      addToInquiry(1);
    });
  }

  var modalContact = $('[data-modal-contact]');
  if (modalContact) {
    modalContact.addEventListener('click', function () {
      var qtyInputs = $$('[data-qty]');
      var total = 0;
      qtyInputs.forEach(function (i) { total += Math.max(0, Number(i.value) || 0); });
      if (!qtyInputs.length) total = 1;
      if (total === 0) { showToast('Please select at least one quantity'); return; }
      addToInquiry(total);
    });
  }

  /* ---------------- review form ---------------- */
  var reviewToggle = $('[data-review-toggle]');
  var reviewForm = $('[data-review-form]');
  if (reviewToggle && reviewForm) {
    reviewToggle.addEventListener('click', function () { reviewForm.hidden = !reviewForm.hidden; });
    var ratingInput = $('[data-review-rating]');
    $$('[data-review-stars] [data-star]').forEach(function (star) {
      star.addEventListener('click', function () {
        var val = Number(star.getAttribute('data-star'));
        if (ratingInput) ratingInput.value = String(val);
        $$('[data-review-stars] [data-star]').forEach(function (s) {
          s.classList.toggle('on', Number(s.getAttribute('data-star')) <= val);
        });
      });
    });
    reviewForm.addEventListener('submit', function (e) {
      e.preventDefault();
      reviewForm.hidden = true;
      reviewForm.reset();
      if (ratingInput) ratingInput.value = '0';
      $$('[data-review-stars] [data-star]').forEach(function (s) { s.classList.remove('on'); });
      showToast('Review submitted, pending moderation');
    });
  }
})();
